import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export class UserPreferencesRetentionManagementCtrl {
	constructor(Api, Cfg, Identity) {
		'ngInject';
		this.Api = Api;

		this.user = Identity.user();
		this.currentClient = Identity.currentClient();

		this.retentionManagementNotifications = Cfg.readAsBool('Features.retention_management_notifications');
		this.retentionManagementExpirationOffset = Cfg.readAsInt('Features.retention_management_expiration_offset');
		this.allowedRententionManagementExpirationOffsets = [
			{ value: 7, name: 'One week' },
			{ value: 14, name: 'Two weeks' },
			{ value: 30, name: 'One month' },
		];

		this.setRetentionManagementNotification = async oldValue => {
			const newValue = !oldValue;

			const resp = await Api.request('POST', '/v2/config/preference/user', {
				code: 'Features.retention_management_notifications',
				value: newValue ? '1' : '0', // IMPORTANT: It is required that the value parameter arrive as a string.
			});

			if (resp.status === 200) {
				this.retentionManagementNotifications = newValue;
			} else {
				alert('An unexpected interruption occurred while saving. Please try your request again.');
			}
		};

		this.setRetentionManagementExpirationOffset = async newValue => {
			const resp = await Api.request('POST', '/v2/config/preference/user', {
				code: 'Features.retention_management_expiration_offset',
				value: String(newValue), // IMPORTANT: It is required that the value parameter arrive as a string.
			});

			if (resp.status === 200) {
				this.retentionManagementExpirationOffset = newValue;
			} else {
				alert('An unexpected interruption occurred while saving. Please try your request again.');
			}
		};
	}
}

export function UserPreferencesRetentionManagementRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.RetentionManagement', {
		url: '/preferences/retention_management',
		controllerAs: 'vm',
		controller: UserPreferencesRetentionManagementCtrl,
		templateUrl:
			'/ng/hub/User/Preferences/RetentionManagement/UserPreferencesRetentionManagementCtrl.html?' + window.BUILD,
		permission: ['publish'],
		resolve: {
			style: () =>
				AssetManager.css('/ng/hub/User/Preferences/RetentionManagement/UserPreferencesRetentionManagementCtrl.css'),
			$title: () => 'Retention Management',
			icons: () => AssetManager.css('/assets/fonts/Linearicons/style.css'),
		},
	});
}
